namespace GeniuzPOS.ReportMasterData {
    export class Report_1201_RecvColumns {
        static columnsKey = 'ReportMasterData.Report_1201_Recv';
    }
}
